import React from "react";

import { PagedResources } from "@common/pagedResources";
import { Props } from "./types";
import { Resource } from "./resource";
import styles from "./styles.scss";

// Without a given list, every planzone resource, searched and paginated by the back.
function Resources({ resources, search, selected, onSelect }: Props) {
  const renderResources = (
    list: NonNullable<Props["resources"]>,
  ): React.ReactNode =>
    list.map((resource) => (
      <Resource
        key={resource.uuid}
        resource={resource}
        selected={selected?.uuid === resource.uuid}
        onSelect={onSelect}
      />
    ));

  return resources ? (
    <div className={styles.resources}>
      {renderResources(
        resources.filter((resource) =>
          resource.name.toLowerCase().includes(search.toLowerCase()),
        ),
      )}
    </div>
  ) : (
    <PagedResources
      flagName="resourceSelectionFlag"
      search={search}
      className={styles.pagedResources}
    >
      {renderResources}
    </PagedResources>
  );
}

export { Resources };
